"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextField = exports.getFieldsToClear = void 0;
var order = [
    'brand',
    'model',
    'generation',
    'year',
    'body',
    'modification',
];
var getFieldsToClear = function (field) {
    var index = order.indexOf(field);
    if (index === -1) {
        return [];
    }
    return order.slice(index + 1);
};
exports.getFieldsToClear = getFieldsToClear;
var getNextField = function (field) {
    var index = order.indexOf(field);
    return order[index + 1];
};
exports.getNextField = getNextField;
